export default "__VITE_ASSET__Z_MmajEr__"